"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PickupPointsMap = void 0;
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _hooks = require("../../hooks");
var _models = require("../../models");
var _ZoomButtons = require("../SelectPickupPointDialog/components/ZoomButtons");
var _shared = require("../shared");
var _MapFactory = require("./MapFactory");
var _PickupPointsMapDetail = require("./PickupPointsMapDetail");
var _jsxRuntime = require("react/jsx-runtime");
const MapContainer = (0, _mui.styled)('div')(({
  ownerState: {
    isMapVisible
  }
}) => ({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  overflow: 'hidden',
  position: 'relative',
  width: '100%',
  ...(!isMapVisible && _shared.hiddenMapStyles)
}));
const NavigationBar = (0, _mui.styled)('div')(({
  ownerState: {
    isCurrentLocationButtonVisible
  },
  theme
}) => ({
  bottom: theme.spacing(isCurrentLocationButtonVisible ? 15 : 4),
  position: 'absolute',
  right: theme.spacing(4),
  zIndex: 999 // displayed under the selected details info
}));
const CurrentLocationButton = (0, _mui.styled)(_components.IconButton)(({
  theme
}) => ({
  bottom: theme.spacing(4),
  position: 'absolute',
  right: theme.spacing(4),
  zIndex: 999 // displayed under the selected details info
}));

// TODO: Remove after flat selection UI is used in all markets
const PickupPointsMap = ({
  activeFilter,
  instantResultChannelId,
  instantSearchTerm,
  isMapVisible,
  selectedMapPickupPoint: selectedPickupPoint
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    currentLocation,
    isCurrentLocationButtonVisible,
    locatePositionInMap
  } = (0, _hooks.useMapLocation)({
    instantResultChannelId,
    isActive: isMapVisible
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(MapContainer, {
    "data-testid": getTestId(_models.TestId.MapContainer),
    ownerState: {
      isMapVisible
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_MapFactory.MapFactory, {
      activeFilter: activeFilter,
      instantSearchTerm: instantSearchTerm,
      isMapVisible: isMapVisible,
      selectedDeliveryChannel: selectedPickupPoint?.deliveryChannelId
    }), isMapVisible && selectedPickupPoint !== undefined ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_PickupPointsMapDetail.PickupPointsMapDetail, {
      selectedPickupPoint: selectedPickupPoint
    }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(NavigationBar, {
      ownerState: {
        isCurrentLocationButtonVisible
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ZoomButtons.ZoomButtons, {})
    }), isCurrentLocationButtonVisible ? /*#__PURE__*/(0, _jsxRuntime.jsx)(CurrentLocationButton, {
      color: "default",
      size: "large",
      variant: "contained"
      // eslint-disable-next-line react/jsx-no-bind -- not an issue
      ,

      onClick: () => locatePositionInMap(currentLocation, _models.MapLocationType.CurrentButton),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.MapSelector, {})
    }) : null]
  });
};
exports.PickupPointsMap = PickupPointsMap;
var _default = exports.default = PickupPointsMap;